import Loader from "../components/Loader";
import React, {useEffect, useRef, useState} from "react";
import {UsersService} from "../services/UsersService";
import {DepartmentService} from "../services/DepartmentService";
import withRouter from '../components/WithRouter'
import {Checkbox} from "primereact/checkbox";
import {useFormik} from "formik";
import {Toast} from 'primereact/toast'
import {classNames} from "primereact/utils";
import {useParams} from "react-router-dom";
import {Tooltip} from 'primereact/tooltip';
import {Badge} from "primereact/badge";

export default function UserEditAccess() {

    const props = useParams()
    const [group, setGroup] = useState('')
    const [auths, setAuths] = useState([])
    const [loading, setLoading] = useState(true)
    const toast = useRef()
    const userId = props.userId

    const formik = useFormik({
        validate: (values) => {
            const errors = {}
        },
        onSubmit: (data) => {
            // let sendindData = [];
            // data.map((checked, name) => {
            //     if(checked) {
            //         sendindData.push(name)
            //     }
            // })
            setLoading(true)

            UsersService.SaveAccessList(userId, data).then((response) => {
                setLoading(false)
                if (response === null) {
                    toast.current.show({severity: 'success', summary: 'Права успешно изменены!'});
                } else {
                    toast.current.show({severity: 'error', summary: 'Ошибка!'});
                }
            })
        }
    })

    useEffect(() => {
        UsersService.GetAuths(userId).then((response) => {
            setAuths(response)
        })
    }, []);

    useEffect(() => {
        if (auths && auths.length > 0) {
            let data = {}
            auths.map((el, k) => {
                data = {...data, [el.name]: el.checked}
            })
            formik.setValues(data)
            setLoading(false)

        }
    }, [auths]);

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    let groupTitle = ''

    return (
        <div className="card">

            <div className="card-body">
                <form className={'theme-form'} onSubmit={formik.handleSubmit}>
                    <Toast ref={toast}/>

                    <h3 className={'m-b-10'}>Настройки доступа</h3>

                    <Tooltip target=".disabled-access" autoHide={false}>Возможность управляется должностью. Ее нельзя
                        удалить.</Tooltip>

                    <small className={'m-b-30 d-block'}>Права, установленные должностью, деактивированы и убрать
                        нельзя.</small>

                    {(auths.length && !loading) ? auths.map((el, k) => {

                        let title = '';

                        if (groupTitle !== el.group) {
                            title = <strong className={'m-b-10'}>{el.group}</strong>
                            groupTitle = el.group
                        }


                        return (
                            <div className={''}>
                                {title}

                                <div key={'access-' + k} className={"d-flex align-items-center checkbox-flex "}>
                                    <Checkbox
                                        inputId={"access-" + k}
                                        name={el.name}
                                        checked={formik.values[el.name]}
                                        className={classNames({'p-invalid': isFormFieldInvalid('checked')})}
                                        onChange={(e) => {
                                            formik.setFieldValue(el.name, e.checked);
                                        }}
                                        disabled={!!auths.find((ael) => ael.name === el.name).disabled}
                                    />
                                    <label htmlFor={'access-' + k} className="m-l-10">{el.description}</label>

                                </div>

                                {getFormErrorMessage('checked')}

                            </div>
                        )
                    }) : <Loader/>}

                    {!loading &&
                        <>
                            <br/>
                            <br/>
                            <button type={'submit'} className={'btn btn-primary'}>Сохранить</button>
                        </>
                    }
                </form>
            </div>
        </div>
    )


}
